import moment from 'moment-timezone'
import { createConfirmation } from 'react-confirm'
import ConfirmDialog from './components/ConfirmDialog'

/**
 * Currency info
 */
export const currencies = [
  { name: 'dollar', code: 'USD', icon: ['far', 'dollar-sign'] },
  { name: 'euro', code: 'EUR', icon: ['far', 'euro-sign'] },
  { name: 'hryvnia', code: 'UAH', icon: ['far', 'hryvnia'] },
  { name: 'lira', code: 'TRY', icon: ['far', 'lira-sign'] },
  { name: 'pound', code: 'GBP', icon: ['far', 'pound-sign'] },
  { name: 'ruble', code: 'RUB', icon: ['far', 'ruble-sign'] },
  { name: 'rupee', code: 'INR', icon: ['far', 'rupee-sign'] },
  { name: 'shekel', code: 'ILS', icon: ['far', 'shekel-sign'] },
  { name: 'tenge', code: 'KZT', icon: ['far', 'tenge'] },
  { name: 'won', code: 'KRW', icon: ['far', 'won-sign'] },
  { name: 'yen', code: 'JPY', icon: ['far', 'yen-sign'] },
]

/*
 * Confirm
 *
 * Show a confirm dialog
 */
export const confirm = (confirmation, options) =>
  createConfirmation(ConfirmDialog)({ confirmation, options })

/**
 * Sleep for a period of time
 */
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

/**
 * Parse error message from an axios error
 *
 * Passes server response through (if a response was found) and includes
 * the axios error message.
 */
export const parseError = ({
  message,
  response: {
    data: { non_field_errors, ...field_errors },
  },
}) => ({
  message,
  non_field_errors,
  field_errors,
})

/**
 * Calculate hours, minutes, and seconds given seconds
 */
const HOURS = 3600
const MINUTES = 60
export const timeParts = seconds => ({
  h: Math.floor(seconds / HOURS),
  m: Math.floor((seconds % HOURS) / MINUTES),
  s: Math.floor((seconds % HOURS) % MINUTES),
})

/**
 * Get duration
 *
 * Take a list of times and calculate the total duration
 */
export const getDuration = times => {
  let duration = 0
  let data = [...times]
  while (data.length > 0) {
    let [start, end] = data.splice(0, 2)
    start = moment(start)
    end = (end && moment(end)) || moment()
    duration += Math.trunc(end.diff(start) / 1000)
  }
  return timeParts(duration)
}
